import { useMemo } from "react";
import { useUser } from "../use-user";
import { isSuperAdminUser, resolveSessionUser } from "../../utils/adminSession";

export const useAdminSession = () => {
  const userQuery = useUser();

  const currentUser = useMemo(
    () => resolveSessionUser(userQuery.data),
    [userQuery.data],
  );

  return {
    ...userQuery,
    currentUser,
    isSuperAdmin: isSuperAdminUser(currentUser),
  };
};
